<CustomWizardCategorySettings @category={{this.category}} />